import React from 'react';

/**
 * Logo De Lima - Imagem original com fundo branco
 */
export function DelimaLogo({ variant = 'default', className = '' }) {
  if (variant === 'login') {
    return (
      <div className={`flex items-center gap-4 ${className}`}>
        <img
          src="/logo-delima.jpg"
          alt="De Lima Comercio e Navegacao"
          className="h-16 w-auto rounded-lg border border-[#007030]/20 bg-white p-1.5"
        />
        <div>
          <p className="text-[10px] text-[#3CB371]/60 font-medium tracking-[0.15em] uppercase">Sistema de Monitoramento</p>
          <div className="h-[1.5px] bg-gradient-to-r from-[#007030] to-[#3CB371]/30 mt-1 rounded-full w-full" />
        </div>
      </div>
    );
  }

  if (variant === 'mobile') {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <img
          src="/logo-delima.jpg"
          alt="De Lima"
          className="h-12 w-auto rounded border border-[#007030]/20 bg-white p-1"
        />
      </div>
    );
  }

  // default = sidebar
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/logo-delima.jpg"
        alt="De Lima"
        className="h-10 w-auto rounded border border-[#007030]/25 bg-white p-0.5"
      />
    </div>
  );
}

export default DelimaLogo;
